import { c as _c } from "react/compiler-runtime";
import { Download, Share, X } from "lucide-react";
import { useEffect, useState } from "react";
import { claimInstallPrompt, dismissInstallPrompt, isIosSafari, promptInstall, useInstallState } from "@/lib/pwa";
import { cn } from "@/lib/utils";

// «Установить приложение» (fd-web-04): на главной — плашка над нижним меню,
// в профиле — карточка под разделами. Показывается один раз за сессию: где
// появилась первой, там и живёт (см. claimInstallPrompt). Chrome/Edge/Android
// ставят по кнопке (beforeinstallprompt), на iPhone — подсказка «На экран Домой».
export function InstallAppPrompt(t0) {
  const $ = _c(27);
  const {
    placement
  } = t0;
  const state = useInstallState();
  const [ios] = useState(isIosSafari);
  const available = !state.installed && (state.canPrompt || ios);
  const [visible, setVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] !== available || $[1] !== placement) {
    t1 = () => {
      if (available) {
        setVisible(claimInstallPrompt(placement));
      } else {
        setVisible(false);
      }
    };
    t2 = [available, placement];
    $[0] = available;
    $[1] = placement;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!visible) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      dismissInstallPrompt();
      setVisible(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const close = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = async () => {
      const accepted = await promptInstall();
      if (accepted) {
        close();
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const install = t4;
  const t5 = placement === "home" ? "bg-white shadow-[0_8px_32px_rgba(0,0,0,0.16)]" : "bg-[#F8F8F8]";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("flex items-start gap-3 rounded-[20px] p-4", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <img src="/icons/icon-192.png" alt="" className="size-11 shrink-0 rounded-[10px]" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#161616]">Приложение OSMIX</p>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== ios || $[11] !== placement || $[12] !== state.canPrompt) {
    t9 = ios && !state.canPrompt ? <>Нажмите <Share className="inline size-4 -translate-y-0.5" aria-label={"\xAB\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xBB"} /> и выберите «На экран Домой» - витрина откроется как приложение.</> : placement === "profile" ? "\u041E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u043C \u043E\u043A\u043D\u0435, \u0431\u0435\u0437 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0438." : "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0438\u0442\u0440\u0438\u043D\u0443 \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0438\u043B\u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440 - \u043E\u043D\u0430 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u043C \u043E\u043A\u043D\u0435, \u0431\u0435\u0437 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0438.";
    $[10] = ios;
    $[11] = placement;
    $[12] = state.canPrompt;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t8}<p className="text-[13px] leading-[18px] text-[#1F1F1F]/64">{t9}</p></div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== state.canPrompt) {
    t11 = state.canPrompt && <button type="button" onClick={() => void install()} className="inline-flex h-10 items-center gap-2 self-start rounded-[10px] bg-[#2E2E2E] px-4 text-[14px] leading-[18px] font-semibold text-white outline-none hover:bg-[#1F1F1F] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><Download className="size-4" aria-hidden="true" />Установить приложение</button>;
    $[16] = state.canPrompt;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <div className="flex min-w-0 flex-1 flex-col gap-2.5">{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <button type="button" onClick={close} aria-label={"\u0417\u0430\u043A\u0440\u044B\u0442\u044C"} className="-mt-1 -mr-1 grid size-8 shrink-0 place-items-center rounded-full text-[#1F1F1F]/56 outline-none hover:bg-black/5 focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><X className="size-4" /></button>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t6) {
    t14 = <div role="dialog" aria-label={"\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 OSMIX"} className={t6}>{t7}{t12}{t13}</div>;
    $[22] = t12;
    $[23] = t6;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const card = t14;
  if (placement === "profile") {
    return card;
  }
  let t15;
  if ($[25] !== card) {
    t15 = <div className="pointer-events-none fixed inset-x-0 bottom-[calc(88px+env(safe-area-inset-bottom))] z-40 px-4 lg:bottom-6 lg:left-auto lg:right-6 lg:w-[400px] lg:px-0"><div className="pointer-events-auto mx-auto max-w-[420px]">{card}</div></div>;
    $[25] = card;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}